/* ===================================================================
   KAAYU - JUDGE.ME REVIEW WIDGET: header stars

   The widget's minimal header prints the rating as text ("5.0") and the count
   ("10 reviews"), and renders no star element beside them. This publishes that
   same number as a percentage on the widget root, so assets/kaayu-reviews-widget.css
   can draw five stars filled to it.

   The number is the widget's own - nothing is invented here. If the header ever
   changes shape, or this script does not run, the custom property is simply
   absent and the CSS draws no stars: the header falls back to the text the app
   rendered, which is what it does today.

   The widget is a Vue app that mounts after this file loads and re-renders on
   sort, filter and pagination, so a one-shot read would miss it. A
   MutationObserver on the widget root keeps the value current, and is cheap
   because it only reads two text nodes.
   =================================================================== */
(function () {
  'use strict';

  var ROOT_ID = 'judgeme_product_reviews';

  function ratingFrom(root) {
    var display = root.querySelector('.jm-average-rating-display');
    if (!display) return null;

    // the first text node in the display is the rating; the second is the count
    var texts = display.querySelectorAll('.jm-text');
    if (!texts.length) return null;

    var value = parseFloat((texts[0].textContent || '').trim());
    if (!isFinite(value) || value <= 0 || value > 5) return null;
    return value;
  }

  function apply(root) {
    var value = ratingFrom(root);
    if (value === null) {
      root.style.removeProperty('--jr-rating-pct');
      root.removeAttribute('data-kaayu-rating');
      return;
    }
    root.style.setProperty('--jr-rating-pct', (value / 5) * 100 + '%');
    // exposed for the accessible label the CSS cannot provide
    root.setAttribute('data-kaayu-rating', value.toFixed(1));
  }

  function start() {
    var root = document.getElementById(ROOT_ID);
    if (!root) return;

    apply(root);

    if (!('MutationObserver' in window)) return;

    var queued = false;
    var observer = new MutationObserver(function () {
      // the Vue app can touch many nodes at once; coalesce into one read
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply(root);
      });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
